import { useEffect, useState } from "react";
import { createHomeSlider, type HomeSlider } from "../../../types/HomeSlider";
import { useLoadingStore } from "../../../store/loadingStore";
import Sliders from "../../../components/Config/HomeConfig/Sliders/Sliders";
import { executeDelete, executeFetch, executePost, executePostForm, executePutForm } from "../../../helper/Api";
import { Exception } from "sass";
import useToastStore from "../../../store/toastStore";
import BrandBanners from "../../../components/Config/HomeConfig/BrandBanners/BrandBanners";
import { HomeBrandBanner } from "../../../types/HomeBrandBanner";

export default function HomeBrandBanners() {
    // States
    const [banners, setBanners] = useState<HomeBrandBanner[]>([]);
    const [bannerCounter,setBannerCounter] = useState<number>(0);
    const {setLoading} = useLoadingStore();
    const {showToast} = useToastStore();

    //Actions
    const handleAddBanner = async () => {
      const newBanner = createHomeSlider();
      newBanner.index = bannerCounter + 1;
      setLoading(true);
      const addBannerResult = await executePost<HomeBrandBanner,HomeBrandBanner>('Settings/AddHomeBrandBanner',newBanner,{admin:true});
      if(addBannerResult.error){
         showToast('Something went wrong adding brand banner!','error');
         console.error(addBannerResult.error.message);
      }else{
        showToast('Successfully added new brand banner!','success');
        setBanners([...banners, addBannerResult.data]);
      }
      setLoading(false);
    };

    const handleRemoveBanner = async (id: string) => {
      setLoading(true);
      const deleteBannerResult = await executeDelete('Settings/DeleteHomeBrandBanner',id,{admin:true});
      if(deleteBannerResult.error){
         showToast('Something went wrong deleting brand banner!','error');
         console.error(deleteBannerResult.error.message);
      }else{
        showToast('Successfully deleted the brand banner!','success')
        setBanners(banners.filter(slider => slider.id !== id));
      }
      setLoading(false);
    };


    const handleUpdateBanner = (updatedBanner: HomeBrandBanner) => {
      setBanners(banners.map(banner => 
        banner.id === updatedBanner.id ? updatedBanner : banner
      ));
    };

    const getFileNameFromUrl = (url: string) => {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1];
    };

 

    const updateBanner = async (brandBanner : HomeBrandBanner, image : File | null) => {
          const payLoad = new FormData();
          if (brandBanner.image) {
            brandBanner.image = getFileNameFromUrl(brandBanner.image);
          }
          payLoad.append('brandBannerString',JSON.stringify(brandBanner));
          payLoad.append('image',image);
          setLoading(true);
        const updateBannerResult = await executePutForm<HomeSlider>('Settings/UpdateHomeBrandBanner',payLoad,{admin:true});
        if(updateBannerResult.error){
          showToast('Something went wrong updating brand banner!','error')
          console.error(updateBannerResult.error.message);
        }else{
          showToast('Successfully update the brand banner!','success')
          setBanners(prev =>
            prev.map(s => s.id === updateBannerResult.data?.id ? updateBannerResult.data! : s)
          );
        }
        setLoading(false);      
    }

    //Effects

    useEffect(()=>{
      const fetchHomeBrandBanners=async () => {
        setLoading(true);
        //fetch home sliders
        const homeBannersResp = await executeFetch<HomeBrandBanner[]>('Settings/GetHomeBrandBanners',{admin:true});
        if(homeBannersResp.error){
           console.error(homeBannersResp.error.message)
        }else{
          const sortedBanners = homeBannersResp.data.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
          setBanners(sortedBanners);
          setBannerCounter(homeBannersResp.data.length)
        }
        setLoading(false);
      }
      fetchHomeBrandBanners();
    },[])

    useEffect(()=>{
      if(bannerCounter!=banners.length){
        setBannerCounter(banners.length)
      }
    
    },[banners])

    useEffect(()=>{
      const sortedBanners = banners.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      setBanners(sortedBanners)
    },[bannerCounter])
    
    return (
        <div className="admin-section home-banners">
        <BrandBanners
          banners={banners}
          onAdd={handleAddBanner}
          onRemove={handleRemoveBanner}
          onUpdate={handleUpdateBanner}
          updateSlider={updateBanner}
        />
        </div>
    );
  };
  
  